const eventFormCourtLogosStyles = (logoPositions) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },

  // ---- Competition logo (used by EventTeamsFields on the Details tab) ----
  competitionFieldsWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 15,
    '& img': {
      objectPosition: 'center',
    },
  },
  competitionLogo: {
    position: 'relative',
    boxSizing: 'border-box',
    flex: 'none',
    width: 46,
    height: 46,
    minWidth: 46,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#bdbdbd',
    borderRadius: 10,
    '& svg': {
      width: '50%',
      height: '50%',
    },
  },
  competitionLogoFilled: {
    position: 'relative',
    boxSizing: 'border-box',
    flex: 'none',
    width: 46,
    height: 46,
    minWidth: 46,
  },

  // ---- Basketball: crisp inline SVG court (design import) ----
  courtOuter: {
    // no overflow clip here so the camera marker can straddle the bottom edge
    position: 'relative',
    width: '100%',
  },
  courtSvgWrapper: {
    position: 'relative',
    width: '100%',
    // cropped to the court bounds (+margin) so the court fills the full width like the button above
    aspectRatio: '560 / 320',
    borderRadius: 8,
    background: '#fff',
    overflow: 'hidden',
  },
  courtSvg: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
  },
  // Dark rounded logo button; a picked image fills the box.
  logoBox: {
    position: 'absolute',
    width: 34,
    height: 34,
    minWidth: 34,
    borderRadius: 7,
    backgroundColor: '#3C3C3C',
    color: '#fff',
    transform: 'translate(-50%, -50%)',
    overflow: 'hidden',
  },
  // Center logo is circular, matching the court's center circle and the mobile app.
  logoBoxCenter: {
    position: 'absolute',
    width: 34,
    height: 34,
    minWidth: 34,
    borderRadius: '50%',
    backgroundColor: '#3C3C3C',
    color: '#fff',
    transform: 'translate(-50%, -50%)',
    overflow: 'hidden',
  },
  // positions in the cropped (560x320) viewBox coordinate space; corners nudged inward
  // horizontally and outward vertically so they sit in the clear space, off the 3-point arcs
  posTopLeft: { left: '36%', top: '21%' },
  posBottomLeft: { left: '36%', top: '79%' },
  posCenter: { left: '50%', top: '50%' },
  posTopRight: { left: '64%', top: '21%' },
  posBottomRight: { left: '64%', top: '79%' },
  // Red camera-position marker: centre sits on the bottom end of the centre line.
  cameraMarker: {
    position: 'absolute',
    left: '50%',
    top: '98.75%',
    transform: 'translate(-50%, -50%)',
    width: 38,
    height: 38,
    borderRadius: '50%',
    backgroundColor: '#E06E5C',
    border: '2.5px solid #fff',
    boxShadow: '0 1px 4px rgba(0,0,0,.25)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cameraIcon: {
    '&&': {
      transform: 'rotate(-90deg)',
      color: '#fff',
      fontSize: 22,
    },
  },

  // ---- Volleyball: existing image-based court ----
  courtWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  courtImg: {
    width: '100%',
    height: '100%',
  },
  editBoxTopLeft: { position: 'absolute', ...logoPositions?.topLeft },
  editBoxTopRight: { position: 'absolute', ...logoPositions?.topRight },
  editBoxBottomLeft: { position: 'absolute', ...logoPositions?.bottomLeft },
  editBoxBottomRight: { position: 'absolute', ...logoPositions?.bottomRight },
})

export default eventFormCourtLogosStyles
